module.exports = __webpack_public_path__ + "static/media/Barmag Spindle.83d148fe.jpg";